import React, { useEffect, useRef, Fragment } from "react";
import ReactDOM from "react-dom";
import styles from "./style.module.css";

const Popover = ({
  open,
  buttonRef,
  children,
  onClose,
  customClass = "",
  position = "top",
  maxWidth,
}) => {
  const popOverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickOutsideButton =
        buttonRef.current && !buttonRef.current.contains(event.target);
      const isClickOutsideContent =
        popOverRef.current && !popOverRef.current.contains(event.target);
      if (isClickOutsideButton && isClickOutsideContent) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [buttonRef, onClose]);

  return (
    <Fragment>
      {open &&
        ReactDOM.createPortal(
          <div
            ref={popOverRef}
            className={`${styles.popover_content} ${customClass}`}
            style={{
              transform: `translate(${
                buttonRef.current?.getBoundingClientRect().left
              }px, ${buttonRef.current?.getBoundingClientRect().bottom}px)`,
              maxWidth: maxWidth || buttonRef.current?.offsetWidth + "px",
              zIndex: 1000,
            }}
          >
            {children}
          </div>,
          document.body
        )}
    </Fragment>
  );
};

export default Popover;
